module.exports = __webpack_public_path__ + "img/_1.2a95d13c.png";